module.exports = __webpack_public_path__ + "1b618e405ccf33336f404119a5b590e7.svg";